.wrap {
  padding: 70px 26px 0;
  text-align: center;
}
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 42px;
}
.line {
  width: 46px;
  height: 1px;
  background: var(--rule);
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: radial-gradient(circle at 32% 28%, #ffffff 0%, #f5ede2 38%, #e0d4c1 70%, #cdbda4 100%);
  box-shadow: 0 2px 5px rgba(120, 100, 70, 0.3);
}
.eyebrow {
  font-family: var(--font-script);
  font-size: 24px;
  color: var(--pink);
}
.title {
  margin: 2px 0 0;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 27px;
  letter-spacing: 3px;
  text-indent: 2px;
  color: var(--ink-2);
}
.venue {
  margin-top: 10px;
  font-family: var(--font-label);
  font-weight: 700;
  font-size: 16.5px;
  letter-spacing: 1px;
  color: var(--muted);
}
.mapCard {
  position: relative;
  border: 1px solid var(--rule-2);
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
  margin-top: 18px;
  box-shadow: 0 10px 26px rgba(120, 100, 70, 0.09);
}
.mapEl {
  height: 300px;
  width: 100%;
  background: #eef1f4;
  position: relative;
  z-index: 0;
}
.mapFallback {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(238, 241, 244, 0.94);
  font-family: var(--font-detail);
  font-size: 13px;
  color: var(--pink-deep);
  text-decoration: underline;
  text-underline-offset: 4px;
}
.addressBlock {
  margin-top: 22px;
}
.label {
  font-family: var(--font-detail);
  font-weight: 400;
  font-size: 11px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 3px;
  text-indent: 3px;
  color: var(--pink);
}
.addressRow {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 10px;
  margin-top: 7px;
}
.addressText {
  font-family: var(--font-detail);
  font-size: 15px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 0.3px;
  color: var(--ink-3);
}
.copyBtn {
  composes: tapTarget from '../styles/tapTarget.module.css';
  border: none;
  border-bottom: 1px solid #c6ced7;
  background: none;
  padding: 0 1px 3px;
  font-family: var(--font-detail);
  font-weight: 400;
  font-size: 11.5px;
  line-height: var(--font-detail-line-height);
  color: var(--muted);
  cursor: pointer;
}
.transitGrid {
  display: grid;
  gap: 14px;
  margin-top: 22px;
}
.transitText {
  margin-top: 5px;
  font-family: var(--font-detail);
  font-size: 14.5px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 0.3px;
  color: var(--ink-4);
}
.linksRow {
  margin-top: 30px;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}
.linksLabel {
  font-family: var(--font-detail);
  font-weight: 400;
  font-size: 11px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 3px;
  color: var(--pink);
  flex-shrink: 0;
}
.linksWrap {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.mapAppLink {
  composes: tapTarget from '../styles/tapTarget.module.css';
  font-family: var(--font-detail);
  font-weight: 400;
  font-size: 13px;
  line-height: var(--font-detail-line-height);
  color: var(--ink-4);
  border-bottom: 1px solid var(--rule);
  padding-bottom: 3px;
  cursor: pointer;
}
